import { useQuery } from "@tanstack/react-query";
import { fetchDirectorSummary } from "@/api/director";

const ONE_MINUTE = 60_000;

/** S5 — Director Home org-wide summary (?scope=all → directorSummary). */
export function useDirectorSummary(enabled = true) {
  return useQuery({
    queryKey: ["directorSummary"],
    queryFn: ({ signal }) => fetchDirectorSummary(signal),
    staleTime: ONE_MINUTE,
    enabled,
  });
}
